(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["solis-chair-upgrades"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('solis-chair-upgrades')) {
    customElements.define('solis-chair-upgrades', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD', maximumFractionDigits: 0 });
        this.addEventListener('change', (event) => {
          const radio = event.target.closest('[data-sr-upgrade-variant]');
          if (radio) {
            const item = radio.closest('.sr-upgrades__item');
            const check = item.querySelector('[data-sr-upgrade]');
            check.value = radio.value;
            check.dataset.price = radio.dataset.price;
            item.querySelector('[data-sr-upgrade-price]').textContent = '+' + this.money.format(radio.dataset.price / 100);
            check.checked = true;
          }
          this.summarize();
        });
        this.onCart = (event) => {
          const data = event.detail && event.detail.data;
          if (!data || data.source !== 'product-form-component' || data.didError) return;
          if (String(data.productId) !== String(this.dataset.productId)) return;
          this.addSelected();
        };
        document.addEventListener('cart:update', this.onCart);
      }

      disconnectedCallback() {
        if (this.onCart) document.removeEventListener('cart:update', this.onCart);
      }

      selected() {
        return Array.from(this.querySelectorAll('[data-sr-upgrade]:checked'));
      }

      summarize() {
        const picks = this.selected();
        const out = this.querySelector('[data-sr-upgrade-summary]');
        if (!picks.length) { out.hidden = true; out.textContent = ''; return; }
        const total = picks.reduce((sum, el) => sum + Number(el.dataset.price || 0), 0);
        out.hidden = false;
        out.textContent = picks.length + (picks.length === 1 ? ' add-on' : ' add-ons') + ', ' + this.money.format(total / 100) + ', added to your cart with the chair.';
      }

      async addSelected() {
        const picks = this.selected();
        if (!picks.length || this.busy) return;
        this.busy = true;
        const status = this.querySelector('[data-sr-upgrade-status]');
        try {
          const { CartAddEvent } = await import('@theme/events');
          const sections = Array.from(document.querySelectorAll('cart-items-component')).map((el) => el.dataset.sectionId).filter(Boolean);
          const body = { items: picks.map((el) => ({ id: Number(el.value), quantity: 1 })) };
          if (sections.length) body.sections = sections.join(',');
          const response = await fetch((window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(body)
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'An add-on could not be added.');
          status.hidden = true;
          this.dispatchEvent(new CartAddEvent({}, String(picks[0].value), { source: 'solis-chair-upgrades', itemCount: picks.length, sections: data.sections }));
        } catch (error) {
          status.hidden = false;
          status.setAttribute('data-error', '');
          status.textContent = (error && error.message ? error.message + ' ' : '') + 'Your chair is in the cart; add the upgrade from its page or ask us in chat.';
        } finally {
          this.busy = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["solis-pairs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('solis-pairs')) {
    customElements.define('solis-pairs', class extends HTMLElement {
      async connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-pairing-add]');
          if (button) this.add(button);
        });
        if (this.querySelector('[data-pairing-preview] li, [data-pairing-results] li')) { this.hidden = false; return; }
        if (!this.dataset.productId) return;
        try {
          const response = await fetch(this.dataset.url);
          if (!response.ok) return;
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const block = Array.from(doc.querySelectorAll('solis-pairs')).find(el => el.dataset.productId === this.dataset.productId);
          if (block?.querySelector('[data-pairing-results] li')) { this.innerHTML = block.innerHTML; this.hidden = false; }
        } catch { this.hidden = true; }
      }

      async add(button) {
        if (button.disabled) return;
        const label = button.querySelector('[data-pairing-add-label]');
        const status = button.closest('li')?.querySelector('[data-pairing-status]');
        const setStatus = (text, isError) => {
          if (!status) return;
          status.hidden = !text;
          status.textContent = text;
          if (isError) status.setAttribute('data-error', ''); else status.removeAttribute('data-error');
        };
        button.disabled = true;
        if (label) label.textContent = 'Adding...';
        setStatus('');
        try {
          const { CartAddEvent } = await import('@theme/events');
          const body = new FormData();
          body.append('id', button.dataset.variantId);
          body.append('quantity', '1');
          const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
            .map((el) => el.dataset.sectionId).filter(Boolean);
          if (sectionIds.length) body.append('sections', sectionIds.join(','));
          const response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'This item could not be added.');
          if (label) label.textContent = 'Added';
          setStatus('Added to your cart.');
          this.dispatchEvent(new CartAddEvent({}, String(button.dataset.variantId), {
            source: 'solis-pairs',
            itemCount: 1,
            productId: button.dataset.productId,
            variantId: button.dataset.variantId,
            sections: data.sections
          }));
          setTimeout(() => { if (label) label.textContent = 'Add to cart'; button.disabled = false; }, 2500);
        } catch (error) {
          if (label) label.textContent = 'Add to cart';
          button.disabled = false;
          setStatus(error.message || 'This item could not be added. Please try again.', true);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
